import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../../../../components/Loader";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { mobileScroll } from "common/FunctionUtils";
import { LOCALES } from "common/constants";

const ChangePassword = () => {
  const [passVisible, setPassVisibile] = useState({
    oldPassword: false,
    newPassword: false,
    RepeatPassword: false,
  });

  const [loading, setLoading] = useState(false);
  const [invalidPasswordChars, setInvalidPasswordChars] = useState([]);
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    watch,
    trigger,
    formState: { errors },
  } = useForm();

  const user = useSelector((state) => state.auth.user);
  const language = localStorage.getItem("i18nextLng");

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      await axios.put("/signup/user-update-password", {
        email: user.email,
        ...values,
      });
      toast.success(t("Password updated successfully"));
    } catch (err) {
      if (err?.response?.data) {
        toast.error(t(err?.response?.data?.message));
      } else if (err?.message) {
        toast.error(t(err?.message));
      } else {
        toast.error(t("Something went wrong. Please try again!"));
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    mobileScroll();
  }, []);

    useEffect(() => {
      trigger();
    }, [language]); 

  const validatePasswordChars = (password) => {
    const allowedChars = /^[A-Za-z\d@$!%*?&]*$/;
    const invalidChars = [];
    
    for (let i = 0; i < password.length; i++) {
      const char = password[i];
      if (!allowedChars.test(char) && !invalidChars.includes(char)) {
        invalidChars.push(char);
      }
    }
    
    setInvalidPasswordChars(invalidChars);
    return invalidChars.length === 0;
  };

  return (
    <div className="page-content change_password_cont invoice-space password-space pb-0 chnge_respnve">
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/settings/change-password"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/installningar/andra-losenord"
          />
        )}
      </Helmet>
      {loading && <Loader />}
      <div className="settings">
        <div className="change-password cp">
          <div className="row">
            <h4 className="change_pass_haed accident_ins font-weight-bold">
              {t("Change password")}
            </h4>
            <p className="change-password__text-body___1z-kt">
              {t("changeenter")}
            </p>

            <div className="col-md-10 col-sm-12">
              <form className="fom_group_cls" onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                  <label htmlFor="inputCity"> {t("Current Password")} </label>

                  <input
                    placeholder={t("Current Password")}
                    type={passVisible.oldPassword ? "text" : "password"}
                    id="current-password"
                    className={`form-control ${
                      errors.oldPassword ? "is-invalid" : ""
                    }`}
                    {...register("oldPassword", {
                      required: t("Current password is required"),
                    })}
                  />

                  <div className="input-group-append pr-3">
                    {passVisible.oldPassword ? (
                      <AiOutlineEyeInvisible
                        className="m-auto"
                        size={24}
                        onClick={() =>
                          setPassVisibile({
                            ...passVisible,
                            oldPassword: false,
                          })
                        }
                      />
                    ) : (
                      <AiOutlineEye
                        className="m-auto"
                        size={24}
                        onClick={() =>
                          setPassVisibile({
                            ...passVisible,
                            oldPassword: true,
                          })
                        }
                      />
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="inputState"> {t("New Password")}</label>
                  <input
                    placeholder={t("New Password")}
                    type={passVisible.newPassword ? "text" : "password"}
                    id="new-password"
                    className={`form-control ${
                      errors.newPassword ? "is-invalid" : ""
                    }`}
                    {...register("newPassword", {
                      required: "New password is required",
                      minLength: {
                        value: 8,
                        message: t(
                          "Password must be atleast 8 characters in length"
                        ),
                      },
                      pattern: {
                        value:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/i,
                        message: invalidPasswordChars.length > 0 
                          ? `${t("Only letters, numbers, and these symbols are allowed: @$!%*?&")}. ${t("Invalid characters found:")} ${invalidPasswordChars.join(', ')}.`
                          : t("Password must contain at least one capital letter and one number. Special characters like hyphens (-), accented letters (ö, ä, å, é, ñ, etc.), and symbols (€, £, ©, ®, etc.) are not accepted."),
                      },
                      onChange: (e) => {
                        validatePasswordChars(e.target.value);
                      }
                    })}
                  />
                  <div className="input-group-append pr-3">
                    {passVisible.newPassword ? (
                      <AiOutlineEyeInvisible
                        className="m-auto"
                        size={24}
                        onClick={() =>
                          setPassVisibile({
                            ...passVisible,
                            newPassword: false,
                          })
                        }
                      />
                    ) : (
                      <AiOutlineEye
                        className="m-auto"
                        size={24}
                        onClick={() =>
                          setPassVisibile({
                            ...passVisible,
                            newPassword: true,
                          })
                        }
                      />
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="inputState">{t("Repeat Password")}</label>

                  <input
                    placeholder={t("Repeat Password")}
                    type={passVisible.RepeatPassword ? "text" : "password"}
                    id="repeat-password"
                    className={`form-control ${
                      errors.confirmPassword ? "is-invalid" : ""
                    }`}
                    {...register("confirmPassword", {
                      required: "Confirm new password is required",
                      minLength: {
                        value: 8,
                        message: t(
                          "Password must be atleast 8 characters in length"
                        ),
                      },
                      pattern: {
                        value:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/i,
                        message: invalidPasswordChars.length > 0 
                          ? `${t("Only letters, numbers, and these symbols are allowed: @$!%*?&")}. ${t("Invalid characters found:")} ${invalidPasswordChars.join(', ')}.`
                          : t("Password must contain at least one capital letter and one number. Special characters like hyphens (-), accented letters (ö, ä, å, é, ñ, etc.), and symbols (€, £, ©, ®, etc.) are not accepted."),
                      },
                      validate: (value) =>
                        value === watch("newPassword") ||
                      t("The passwords do not match"),
                      onChange: (e) => {
                        validatePasswordChars(e.target.value);
                      }
                    })}
                  />
                  <div className="input-group-append pr-3">
                    {passVisible.RepeatPassword ? (
                      <AiOutlineEyeInvisible
                        className="m-auto"
                        size={24}
                        onClick={() =>
                          setPassVisibile({
                            ...passVisible,
                            RepeatPassword: false,
                          })
                        }
                      />
                    ) : (
                      <AiOutlineEye
                        className="m-auto"
                        size={24}
                        onClick={() =>
                          setPassVisibile({
                            ...passVisible,
                            RepeatPassword: true,
                          })
                        }
                      />
                    )}
                  </div>
                </div>
                {invalidPasswordChars.length > 0 && (
                  <div className="mt-2 mb-2" style={{ fontSize: "0.95em", color: "red", }}>
                    <span>{t("Invalid characters found:")} {invalidPasswordChars.join(', ')}</span>
                    <br />
                    <small>{t("Only letters, numbers, and these symbols are allowed: @$!%*?&")}</small>
                  </div>
                )}
                {Object.keys(errors).length > 0 && (
                  <div className="w-100">
                    <p className="text-danger">
                    {errors[Object.keys(errors)[0]]?.message}
                    </p>
                  </div>
                )}
                <div className="button-wrapper text-left mt-5 mb-0">
                  <Button
                    type="submit"
                    className="text-light save_add_customer new_theme_btn"
                  >
                    <span>{t("Save Settings")}</span>
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
